
function Footer(){
    return(
        <footer>
        <p>
            &copy; Asta Remeikiene, 2023
        </p>
        </footer>
    )
}

export default Footer;